module.exports = __webpack_public_path__ + "static/media/golfer-1-b.632506ff.png";